

const calculateProrataDepreciation = (acquisition_date, date, depreciation_charge) => {
  let prorataTemporisDate = new Date(acquisition_date); // get prorata date
  let startDepreciatingDate = new Date(date); // get first recognition date
  let prorataTemporisDateRemaining = (startDepreciatingDate - prorataTemporisDate); // calculate prorata days remaining until deferred revenue first recognition
  prorataTemporisDateRemaining = Math.ceil((startDepreciatingDate - prorataTemporisDate) / (1000 * 60 * 60 * 24)) +1;
  let startDepreciatingDate_ =  prorataTemporisDateRemaining + new Date(prorataTemporisDate).getDate() - 1; // sum up the prorata date and the calculated days remaining together
  let prorataTemporisDepreciation = ((depreciation_charge * prorataTemporisDateRemaining) / startDepreciatingDate_).toFixed(2) * 1; // calculate first depreciation amount from the prorata date to the first start date
  console.log(prorataTemporisDateRemaining, depreciation_charge, startDepreciatingDate_)
  return prorataTemporisDepreciation;
};


export default calculateProrataDepreciation;